import { useMutation, useQueryClient } from '@tanstack/react-query'
import { outreachApi, outreachMessagesQueryKey, portfolioMessagesQueryKey } from '../api'

/**
 * Drop the founder's edit for one message and go back to the generated copy.
 *
 * The server RETIRES the custom version rather than deleting it — contacts that
 * already received that text reference it by id — so this is reversible only by
 * editing again, not by undo.
 */
export function useResetOutreachMessageMutation(startupId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (field: 'msg1' | 'msg2' | 'msg3') => outreachApi.resetMessage(startupId, field),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: outreachMessagesQueryKey(startupId) })
    },
  })
}

/** Portfolio twin of {@link useResetOutreachMessageMutation}. */
export function useResetPortfolioMessageMutation(startupId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (field: 'msg1' | 'msg2' | 'msg3') =>
      outreachApi.portfolioResetMessage(startupId, field),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: portfolioMessagesQueryKey(startupId) })
    },
  })
}
